import React from "react";
import "./TableComponent.css";
import { useTheme } from "@emotion/react";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Grid, Typography } from "@mui/material";
const TableComponent = ({ stocks = [], setModalData, setOpen }) => {
  const theme = useTheme();
  return (
    <Box px={{ xs: 1, sm: 1, md: 2 }} pb={2}>
      <Grid
        container
        sx={{
          p: { xs: 1, sm: 2 },
          mt: 1,
          background: "white",
          borderRadius: "12px",
        }}
      >
        <Grid item xs={12}>
          {/* Scrollable Table Wrapper */}
          <Box
            sx={{
              overflowX: "auto",
              width: "100%",
            }}
          >
            <Box sx={{ width: "100%", minWidth: "100%" }}>
              {/* Header */}
              <Grid
                container
                sx={{
                  borderBottom: "1.5px solid black",
                  py: 1,
                  px: { xs: 1, sm: 2, md: 3 },
                  backgroundColor: "#F4F4FF",
                }}
              >
                <Grid item xs={3} sm={2}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "15px" },

                      textAlign: "left",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Item Code
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "15px" },

                      textAlign: "left",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Item Name
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "15px" },

                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Alert Value
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={3}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "15px" },

                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Available Stock
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2}>
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "15px" },

                      textAlign: "center",
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Edit
                  </Typography>
                </Grid>
              </Grid>

              {/* Body */}
              <Box
                sx={{
                  maxHeight: "60vh",
                  overflowY: "auto",
                  mt: 1,
                  pr: 1,
                }}
              >
                {stocks.map((row) => (
                  <Grid
                    container
                    key={row?.id}
                    sx={{
                      p: "8px 0",
                      px: { xs: 1, sm: 1 },
                      color:
                        row?.totalItemQuantity < row?.inventoryAlarmValue
                          ? "red"
                          : "inherit",
                      borderBottom: "1px solid #eee",
                      alignItems: "center",
                      backgroundColor: "#E8E8FF",
                      borderRadius: "8px",
                      mb: 1,
                    }}
                  >
                    <Grid item xs={3} sm={2}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          whiteSpace: {
                            xs: "normal", // allow wrapping on small screens
                            sm: "nowrap", // prevent wrapping on sm and up
                          },
                        }}
                      >
                        {row?.itemCode || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },

                          whiteSpace: {
                            xs: "normal", // allow wrapping on small screens
                            sm: "nowrap", // prevent wrapping on sm and up
                          },
                        }}
                      >
                        {row?.description || "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {row?.inventoryAlarmValue ?? "-"}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sm={3}
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {row?.totalItemQuantity ?? "-"}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      <EditIcon
                        sx={{
                          cursor: "pointer",
                          color: "#01008B",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                        onClick={() => {
                          setOpen(true);
                          setModalData(row);
                        }}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableComponent;
